import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import {
  Text
} from "@chakra-ui/react";

import {
  SectionContainer,
  SectionWrapper
} from "../components/Section";

import Layout from "../components/Layout";
import Head from "../components/Head";

import { Carousel } from "../components/Carousel";
import { PageHero } from "../components/Hero";
import { Tabs } from "../components/Tabs";


const PortfolioPage: React.FC = () => {
  const data: any = useStaticQuery(graphql`
    query {
      page: mdx(
        frontmatter: {
          title: {
            eq: "Portfolio"
          }
        }
      ) {
        frontmatter {
          seo_title
          seo_description
          heading
          subheading
        }
      }

      concrete: allMdx(
        filter: {
          frontmatter: {
            type: {
              eq: "concrete"
            }
          }
        }
      ) {
        edges {
          node {
            frontmatter {
              heading
              project_type
              image {
                childImageSharp {
                  gatsbyImageData(
                    quality: 100
                    placeholder: TRACED_SVG
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
            }
          }
        }
      }

      laneway: allMdx(
        filter: {
          frontmatter: {
            type: {
              eq: "laneway"
            }
          }
        }
      ) {
        edges {
          node {
            frontmatter {
              heading
              project_type
              image {
                childImageSharp {
                  gatsbyImageData(
                    quality: 100
                    placeholder: TRACED_SVG
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
            }
          }
        }
      }

      sumppump: allMdx(
        filter: {
          frontmatter: {
            type: {
              eq: "sump-pump"
            }
          }
        }
      ) {
        edges {
          node {
            frontmatter {
              heading
              project_type
              image {
                childImageSharp {
                  gatsbyImageData(
                    quality: 100
                    placeholder: TRACED_SVG
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
            }
          }
        }
      }

      underpinning: allMdx(
        filter: {
          frontmatter: {
            type: {
              eq: "underpinning"
            }
          }
        }
      ) {
        edges {
          node {
            frontmatter {
              heading
              project_type
              image {
                childImageSharp {
                  gatsbyImageData(
                    quality: 100
                    placeholder: TRACED_SVG
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
            }
          }
        }
      }

      waterproofing: allMdx(
        filter: {
          frontmatter: {
            type: {
              eq: "waterproofing"
            }
          }
        }
      ) {
        edges {
          node {
            frontmatter {
              heading
              project_type
              image {
                childImageSharp {
                  gatsbyImageData(
                    quality: 100
                    placeholder: TRACED_SVG
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
            }
          }
        }
      }

      services: allMdx(
        filter: {
          frontmatter: {
            template: {
              eq: "service"
            }
          }
        }
        sort: {
          fields: [frontmatter___order]
          order: ASC
        }
      ) {
        edges {
          node {
            frontmatter {
              title
              order
            }
            slug
          }
        }
      }

      testimonials: allMdx(
        filter: {
          frontmatter: {
            template: {
              eq: "testimonial"
            }
          }
        }
      ) {
        edges {
          node {
            frontmatter {
              author_name
              author_title
              testimonial
            }
          }
        }
      }
    }
  `);

  return (
    <Layout>
      <Head
        title={ data.page.frontmatter.seo_title }
        description={ data.page.frontmatter.seo_description }
      />

      <SectionWrapper
        background="background.aliceblue"
        padding="153px 0 138px"
      >
        <SectionContainer>
          <PageHero
            heading={ data.page.frontmatter.heading }
            description={ data.page.frontmatter.subheading }
            alignment="left"
          />
        </SectionContainer>
      </SectionWrapper>

      <SectionWrapper
        padding="80px 0"
      >
        <SectionContainer>
          <Tabs
            panels={[
              data.laneway.edges,
              data.underpinning.edges,
              data.waterproofing.edges,
              data.concrete.edges,
              data.sumppump.edges
            ]}
            template="project"
          />
        </SectionContainer>
      </SectionWrapper>

      <SectionWrapper
        background="background.aliceblue"
        padding="110px 0"
      >
        <Carousel
          nodes={ data.testimonials.edges }
          options={{
            loop: true
          }}
          template="testimonial"
          heading={
            <>
              People <Text as="span" color="primary.900">love</Text> what we do
            </>
          }
          headingAlignment="space-between"
        />
      </SectionWrapper>
    </Layout>
  )
}


export default PortfolioPage;
